module.exports = __webpack_public_path__ + "img/report_image.9d64cdf6.png";